import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class NotFoundContainer extends Component {
  render() {
    return (
      <div className="not-found-view">
        <h1>This is a 404 page!</h1>
        <p>{window.location.href}</p>
        <hr />
        <Link to="/">Back To Home View</Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/NotFound/NotFound.view.js